import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DatePicker, BackdropLoader } from '@livable/saas-react-components';
import { Button, Typography, FormControl, InputLabel, OutlinedInput, InputAdornment, ToggleButtonGroup, ToggleButton, TextField, FormHelperText } from '@mui/material';
import useStyles from './../styles';
import moment from 'moment/moment';
import { getRequiredTextMessage } from 'src/utils/formValidation';
export default function ModalContent(_ref) {
  var _title$length, _activeTransaction$de, _activeTransaction$de2;
  let activeTransaction = _ref.activeTransaction,
    onSaveHandler = _ref.onSaveHandler,
    handleCloseExternal = _ref.handleCloseExternal;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState((activeTransaction === null || activeTransaction === void 0 ? void 0 : activeTransaction.endingDateOnly) === null ? moment().endOf('day').toDate() : moment("".concat(activeTransaction === null || activeTransaction === void 0 ? void 0 : activeTransaction.endingDateOnly)).endOf('day').toDate()),
    _useState4 = _slicedToArray(_useState3, 2),
    endingDateOnly = _useState4[0],
    setEndingDateOnly = _useState4[1];
  const _useState5 = useState(activeTransaction.endingCondition || 'OnMoveOut'),
    _useState6 = _slicedToArray(_useState5, 2),
    endingCondition = _useState6[0],
    setEndingCondition = _useState6[1];
  const _useState7 = useState(Number(activeTransaction === null || activeTransaction === void 0 ? void 0 : activeTransaction.amount).toFixed(2) || ''),
    _useState8 = _slicedToArray(_useState7, 2),
    amount = _useState8[0],
    setAmount = _useState8[1];
  const _useState9 = useState((activeTransaction === null || activeTransaction === void 0 ? void 0 : activeTransaction.endingNumberOfOccurrences) || Number(activeTransaction.occuredTimes) || 0),
    _useState0 = _slicedToArray(_useState9, 2),
    endingNumberOfOccurrences = _useState0[0],
    setEndingNumberOfOccurrences = _useState0[1];
  const _useState1 = useState((activeTransaction === null || activeTransaction === void 0 ? void 0 : activeTransaction.memo) || ''),
    _useState10 = _slicedToArray(_useState1, 2),
    memo = _useState10[0],
    setMemo = _useState10[1];
  const _useState11 = useState((activeTransaction === null || activeTransaction === void 0 ? void 0 : activeTransaction.title) || ''),
    _useState12 = _slicedToArray(_useState11, 2),
    title = _useState12[0],
    setTitle = _useState12[1];
  const titleMaxLength = 60;
  const _useState13 = useState((activeTransaction === null || activeTransaction === void 0 ? void 0 : activeTransaction.notes) || ''),
    _useState14 = _slicedToArray(_useState13, 2),
    notes = _useState14[0],
    setNotes = _useState14[1];
  const handleEndsChange = (e, newValue) => {
    if (newValue) {
      setEndingCondition(newValue);
    }
  };
  const handleEndingDate = date => {
    setEndingDateOnly(moment("".concat(date)).endOf('day').toDate());
  };
  const _useState15 = useState(moment().month(activeTransaction.repeatOnMonth - 1).toDate()),
    _useState16 = _slicedToArray(_useState15, 2),
    repeatOnMonth = _useState16[0],
    setRepeatOnMonth = _useState16[1];
  const handleStartDate = _ref2 => {
    let date = _ref2.date;
    setRepeatOnMonth(moment(date).toDate());
  };
  const isModalDataChanged = () => {
    return endingCondition === 'OnDate' && moment(endingDateOnly).endOf('day').toDate().getTime() !== moment(activeTransaction.endingDateOnly).endOf('day').toDate().getTime() || endingCondition !== activeTransaction.endingCondition || Number(amount) !== Number(activeTransaction.amount) || endingNumberOfOccurrences !== activeTransaction.endingNumberOfOccurrences || memo !== activeTransaction.memo || notes !== activeTransaction.notes || title !== activeTransaction.title || moment(repeatOnMonth).format('M') !== moment().month(activeTransaction.repeatOnMonth - 1).format('M');
  };
  const isAmountValid = () => {
    return Number(amount) > 0;
  };
  const isTitleValid = () => {
    return title.length > 0;
  };
  const isNumberOfOccurrencesValid = () => {
    return Number(endingNumberOfOccurrences) >= Number(activeTransaction.occuredTimes);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('post_charge_modal.recurring_charge_title')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(FormControl, {
    className: classes.titleField,
    onChange: e => {
      var _e$target;
      if ((e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value.length) <= titleMaxLength) {
        setTitle(e.target.value);
      }
    },
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "title"
  }, t('post_charge_modal.title')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "title",
    label: t('post_charge_modal.title'),
    type: "text",
    value: title,
    error: !title.length
  }), !title.length && /*#__PURE__*/React.createElement(FormHelperText, null, getRequiredTextMessage('Title')), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, (_title$length = title === null || title === void 0 ? void 0 : title.length) !== null && _title$length !== void 0 ? _title$length : 0, "/", titleMaxLength))), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('resident_account.amount_to_post')), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(classes.smallField)
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "amount"
  }, t('resident_account.enter_amount')), /*#__PURE__*/React.createElement(OutlinedInput, {
    label: t('resident_account.enter_amount'),
    id: "rate",
    type: "number",
    value: amount,
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^\d+([.,]\d{0,2})?$|^$/.test(e.target.value)) return;
      setAmount(e.target.value);
    },
    placeholder: "0.00",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    error: !isAmountValid()
  })), !isAmountValid() && /*#__PURE__*/React.createElement(FormHelperText, null, "Incorrect Amount value")), activeTransaction.repeatRate.toLowerCase() === 'year' && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('post_charge_modal.repeat_on')), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.datePicker, " ").concat(classes.smSection, " ").concat(classes.smallField)
  }, /*#__PURE__*/React.createElement(DatePicker, {
    label: t('post_charge_modal.month'),
    format: "MMMM",
    value: repeatOnMonth,
    onChange: date => handleStartDate({
      date
    }),
    showMonthYearPicker: true,
    minDate: moment().add(1, 'month').toDate()
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.whiteBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, !(activeTransaction !== null && activeTransaction !== void 0 && (_activeTransaction$de = activeTransaction.deactivationInfo) !== null && _activeTransaction$de !== void 0 && _activeTransaction$de.toBeDeactivatedOnNextOccurrence) ? t('resident_account.next_charge_on', {
    date: moment(activeTransaction.nextScheduledDateOnly).format('MM/DD/YYYY'),
    interpolation: {
      escapeValue: false
    }
  }) : t('resident_account.charge_will_be_canceled_on', {
    toBeDeactivatedOnDateOnly: moment(activeTransaction === null || activeTransaction === void 0 || (_activeTransaction$de2 = activeTransaction.deactivationInfo) === null || _activeTransaction$de2 === void 0 ? void 0 : _activeTransaction$de2.toBeDeactivatedOnDateOnly).format('MM/DD/YYYY'),
    interpolation: {
      escapeValue: false
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('resident_account.ends'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: endingCondition,
    onChange: handleEndsChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "OnMoveOut"
  }, t('resident_account.on_move_out')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "OnDate"
  }, t('resident_account.on_date')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "OnNumberOfOccurrences"
  }, t('resident_account.after_occurrences')))), endingCondition === 'OnDate' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(classes.smallField)
  }, /*#__PURE__*/React.createElement(DatePicker, {
    value: endingDateOnly,
    onChange: date => handleEndingDate(date),
    format: "MM/dd/yy",
    label: t('resident_account.select_date'),
    minDate: moment().toDate()
  })), endingCondition === 'OnNumberOfOccurrences' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(classes.smallField)
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('post_charge_modal.num_of_occurances'),
    variant: "outlined",
    fullWidth: true,
    type: "number",
    value: endingNumberOfOccurrences,
    onKeyPress: event => {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      setEndingNumberOfOccurrences(e.target.value);
    },
    error: !isNumberOfOccurrencesValid(),
    helperText: !isNumberOfOccurrencesValid() && 'Current number is less than already occurred times'
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "".concat(Number(activeTransaction.occuredTimes), " of ").concat(endingNumberOfOccurrences, " times occurred"))))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('resident_account.details'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "memo",
    label: t('resident_account.memo'),
    variant: "outlined",
    multiline: true,
    type: "text",
    rows: 4,
    value: memo,
    onChange: e => {
      var _e$target2;
      if ((e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value.length) <= 255) {
        var _e$target3;
        setMemo(e === null || e === void 0 || (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.value);
      }
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, memo.length, "/255")), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "notes",
    label: t('resident_account.notes'),
    variant: "outlined",
    multiline: true,
    type: "text",
    rows: 4,
    value: notes,
    onChange: e => {
      var _e$target4;
      if ((e === null || e === void 0 || (_e$target4 = e.target) === null || _e$target4 === void 0 ? void 0 : _e$target4.value.length) <= 255) {
        var _e$target5;
        setNotes(e === null || e === void 0 || (_e$target5 = e.target) === null || _e$target5 === void 0 ? void 0 : _e$target5.value);
      }
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, notes.length, "/255"))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => {
      handleCloseExternal();
    },
    'custom-attribute': '49-reccuring-charges-table-edit-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    disabled: isLoading || !isModalDataChanged() || !isAmountValid() || !isNumberOfOccurrencesValid() || !isTitleValid(),
    onClick: async () => {
      setIsLoading(true);
      await onSaveHandler(_objectSpread(_objectSpread({}, activeTransaction), {}, {
        title,
        endingDateOnly: moment(endingDateOnly).utc().format('YYYY-MM-DD'),
        endingCondition,
        endingNumberOfOccurrences,
        amount,
        memo,
        notes,
        repeatOnMonth: moment(repeatOnMonth).format('M')
      }));
      setIsLoading(false);
      handleCloseExternal();
    },
    'custom-attribute': '50-reccuring-charges-table-edit-modal'
  }, t('resident_account.submit')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }));
}